import { render, staticRenderFns } from "./ViewingDuration.vue?vue&type=template&id=79ff4f5a&scoped=true"
import script from "./ViewingDuration.vue?vue&type=script&lang=js"
export * from "./ViewingDuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ff4f5a",
  null
  
)

export default component.exports